// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { SET_ASSET_ANNOTATIONS } from "./action";

export function canSetAssetAnnotations(scope: Scope): boolean {
  return scope.iamActions.includes(SET_ASSET_ANNOTATIONS);
}
